import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { useEffect, useState, useMemo } from 'react';
import cloneDeep from 'lodash/cloneDeep';
export var useChecked = function useChecked(value, flattenData, keysData, isMultiple) {
  var initialCheckedState = useMemo(function () {
    return setNodeCheckedByValue(value, flattenData, keysData);
  }, [value, flattenData, keysData]);
  var _useState = useState(initialCheckedState.checkedKeys),
    _useState2 = _slicedToArray(_useState, 2),
    checkedKeys = _useState2[0],
    setCheckedKeys = _useState2[1];
  var _useState3 = useState(initialCheckedState.halfCheckedKeys),
    _useState4 = _slicedToArray(_useState3, 2),
    halfCheckedKeys = _useState4[0],
    setHalfCheckedKeys = _useState4[1];
  useEffect(function () {
    setCheckedKeys(initialCheckedState.checkedKeys);
  }, [initialCheckedState.checkedKeys]);
  useEffect(function () {
    setHalfCheckedKeys(initialCheckedState.halfCheckedKeys);
  }, [initialCheckedState.halfCheckedKeys]);
  if (!isMultiple) return [];
  return [checkedKeys, halfCheckedKeys, setCheckedKeys, setHalfCheckedKeys];
};
export var flattenAll = function flattenAll(data) {
  var newTreeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var keysData = {};
  var formatData = cloneDeep(data);
  var fn = function fn(data) {
    var newTreeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var newParent = cloneDeep(parent);
    if (newParent) {
      newParent.children = null;
    }
    data && data.forEach(function (item) {
      var _context, _context2;
      var children = item.children,
        label = item.label,
        value = item.value,
        others = __rest(item, ["children", "label", "value"]);
      var flattenNode = _extends({
        label: label,
        value: value,
        children: children,
        parent: newParent,
        parentKey: (parent === null || parent === void 0 ? void 0 : parent.value) || null,
        pathKeys: _concatInstanceProperty(_context = []).call(_context, _toConsumableArray((parent === null || parent === void 0 ? void 0 : parent.pathKeys) || []), [value]),
        _level: parent ? parent._level + 1 : 0
      }, others);
      item.parent = newParent;
      item.parentKey = (parent === null || parent === void 0 ? void 0 : parent.value) || null;
      item.pathKeys = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray((parent === null || parent === void 0 ? void 0 : parent.pathKeys) || []), [value]);
      item._level = parent ? parent._level + 1 : 0;
      value && (keysData[value] = flattenNode);
      newTreeData.push(flattenNode);
      children && fn(children, newTreeData, flattenNode);
    });
    return newTreeData;
  };
  var flattenData = fn(formatData, newTreeData);
  return {
    formatData: formatData,
    keysData: keysData,
    flattenData: flattenData
  };
};
export var isHalfChecked = function isHalfChecked(data) {
  var checkedLen = data.reduce(function (total, prev) {
    var num = prev._halfChecked ? 0.5 : prev._checked ? 1 : 0;
    return total + num;
  }, 0);
  return checkedLen !== data.length && checkedLen > 0;
};
export var ValueSeparator = '__kdm_cascader__';
export var transformValuesToSet = function transformValuesToSet(values) {
  var _values = values || [];
  var valuesSet = _values.reduce(function (set, next) {
    var _context3;
    set.add(_concatInstanceProperty(_context3 = []).call(_context3, next).join(ValueSeparator));
    return set;
  }, new _Set());
  return valuesSet;
};
export var valueInSet = function valueInSet(set, value) {
  var _value = value || [];
  return set.has(_value.join(ValueSeparator));
};
export function getChildNodeKeys(node, keysNodeProps) {
  var nodes = new _Set();
  var loop = function loop(children) {
    _mapInstanceProperty(children).call(children, function (child) {
      var key = child.value;
      if (!key) return;
      var item = keysNodeProps[key];
      if (!item || item.disabled) {
        return;
      }
      key && nodes.add(key);
      loop(item.children || []);
    });
  };
  if (node) {
    loop(node.children || []);
  }
  return nodes;
}
export var setNodeCheckedByValue = function setNodeCheckedByValue(initValues, flatNodes, keysNodeProps) {
  var _context4, _context5;
  var valuesSet = transformValuesToSet(initValues);
  var checkedSet = new _Set();
  var halfCheckedSet = new _Set();
  var childCheckedKeysSet = new _Set();
  flatNodes.forEach(function (node) {
    if (node.pathKeys.some(function (_item, index, arr) {
      return valueInSet(valuesSet, _sliceInstanceProperty(arr).call(arr, 0, index + 1));
    })) {
      checkedSet.add(node.value);
    }
  });
  _mapInstanceProperty(_context4 = _toConsumableArray(checkedSet)).call(_context4, function (value) {
    if (!childCheckedKeysSet.has(value)) {
      var childKeys = getChildNodeKeys(keysNodeProps[value], keysNodeProps);
      childKeys.forEach(function (v) {
        childCheckedKeysSet.add(v);
      });
    }
    updateParent(value, keysNodeProps, checkedSet, halfCheckedSet);
  });
  return {
    checkedKeys: _toConsumableArray(new _Set(_concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(checkedSet), _toConsumableArray(childCheckedKeysSet)))),
    halfCheckedKeys: _toConsumableArray(halfCheckedSet)
  };
};
var updateParent = function updateParent(key, keysNodeProps, allKeys, halfCheckedKeysSet) {
  var pathKeys = _toConsumableArray(keysNodeProps[key].pathKeys);
  pathKeys.pop();
  pathKeys.reverse().forEach(function (itemKey) {
    var parent = keysNodeProps[itemKey];
    if (parent && !parent.disabled) {
      var total = 0;
      var number = 0;
      parent.children.some(function (_ref) {
        var value = _ref.value;
        var item = keysNodeProps[value];
        if (!item || item.disabled) {
          return false;
        }
        total++;
        if (allKeys.has(value)) {
          number++;
        } else if (halfCheckedKeysSet.has(value)) {
          number += 0.5;
          return true;
        }
      });
      if (!number || number === total) {
        halfCheckedKeysSet.delete(itemKey);
      } else {
        halfCheckedKeysSet.add(itemKey);
      }
      if (number && number === total) {
        allKeys.add(itemKey);
      } else {
        allKeys.delete(itemKey);
      }
    }
  });
};
export var getHalfChecked = function getHalfChecked(halfCheckedKeys, key) {
  return halfCheckedKeys === null || halfCheckedKeys === void 0 ? void 0 : _includesInstanceProperty(halfCheckedKeys).call(halfCheckedKeys, key);
};
export var getChecked = function getChecked(checkedKeys, key) {
  return checkedKeys === null || checkedKeys === void 0 ? void 0 : _includesInstanceProperty(checkedKeys).call(checkedKeys, key);
};
var getCheckedNodes = function getCheckedNodes(flatNodes, checkedKeys) {
  var result = [];
  for (var i = 0; i < checkedKeys.length; i++) {
    var key = checkedKeys[i];
    for (var j = 0; j < flatNodes.length; j++) {
      var obj = flatNodes[j];
      if (obj.value === key) {
        result.push(obj);
        break;
      }
    }
  }
  return result;
};
export var addKeys = function addKeys() {
  var _context6;
  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _Array$from(new _Set(_concatInstanceProperty(_context6 = []).call(_context6, _toConsumableArray(prevKeys), _toConsumableArray(newKeys))));
};
export var delKey = function delKey(prevKeys, delKeys) {
  var keys = _extends([], prevKeys);
  delKeys.forEach(function (item) {
    var index = keys.indexOf(item);
    index > -1 && _spliceInstanceProperty(keys).call(keys, index, 1);
  });
  return keys;
};
export var getMultipleCheckValue = function getMultipleCheckValue(_propsValue, _option, _checked, flatNodes, checkedKeys) {
  var _context7;
  var checkedNodes = getCheckedNodes(flatNodes, checkedKeys);
  var currentValue = _filterInstanceProperty(_context7 = _mapInstanceProperty(checkedNodes).call(checkedNodes, function (node) {
    return !node.children && node.pathKeys;
  })).call(_context7, function (node) {
    return node;
  });
  return currentValue;
};
export function getAllCheckedKeys(key, checked, checkedKeys, keysNodeProps, halfCheckedKeys) {
  if (!keysNodeProps[key]) {
    return {
      checkedKeys: checkedKeys,
      halfCheckedKeys: halfCheckedKeys
    };
  }
  var checkedKeysSet = new _Set(checkedKeys);
  var halfCheckedKeysSet = new _Set(halfCheckedKeys);
  var childKeys = getChildNodeKeys(keysNodeProps[key], keysNodeProps);
  var allKeys = checkedKeysSet;
  if (checked) {
    allKeys.add(key);
    halfCheckedKeysSet.delete(key);
    childKeys.forEach(function (v) {
      allKeys.add(v);
    });
  } else {
    halfCheckedKeysSet.delete(key);
    allKeys.delete(key);
    childKeys.forEach(function (v) {
      allKeys.delete(v);
    });
  }
  updateParent(key, keysNodeProps, checkedKeysSet, halfCheckedKeysSet);
  return {
    checkedKeys: _toConsumableArray(allKeys),
    halfCheckedKeys: _toConsumableArray(halfCheckedKeysSet)
  };
}